<template>
  <a-card :bordered="false" title="数据统计">
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['s1','s2','s3']"
      :columns="getColumns()"
      :queryParams="queryParams"
      row-key="channelId"
      :leftSpace="10"
      :enable-search="true"
      :show-reset-button="true"
      :requestPromise="getTaskList"
      @reset="onRestEvent"
    >
      <a-form-item slot="s1" label="分销员ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.staffId " placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s2" label="姓名" v-bind="searchItemLayout">
        <a-input v-model="queryParams.name" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s3" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.mobile" placeholder="请输入"></a-input>
      </a-form-item>
      <span slot="packageMoney" slot-scope="rowItem">
        {{ rowItem.record.packageMoney ? rowItem.record.packageMoney : '--' }}
      </span>
      <span slot="receivePackageTime" slot-scope="rowItem">
        {{ rowItem.record.receivePackageTime ? rowItem.record.receivePackageTime : '--' }}
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
//数据统计
import salesTaskMixins from '@/views/service/serviceProvider/salesTask/salesTaskMixins'

export default {
  name: 'MarketingStatistics',
  mixins: [salesTaskMixins],
  data() {
    return {
      taskId: this.$route.query.taskId
    }
  },
  mounted() {
  },

  created() {
    this.queryParams = {
      merchantId: this.merchantId,
      taskId: this.$route.query.taskId
    }
  },
  methods: {
    getColumns() {
      return [
        {
          title: '分销员ID',
          dataIndex: 'staffId'
        },
        {
          title: '店铺名称',
          dataIndex: 'shopName'
        },
        {
          title: '姓名',
          dataIndex: 'staffName'
        },
        {
          title: '手机号',
          dataIndex: 'mobile'
        },
        {
          title: '红包（元）',
          dataIndex: 'packageMoney',
          scopedSlots: { customRender: 'packageMoney' }
        },
        {
          title: '参与时间',
          dataIndex: 'receiveTime'
        },
        {
          title: '获得红包时间',
          dataIndex: 'receivePackageTime',
          scopedSlots: { customRender: 'receivePackageTime' }
        }
      ]
    },
    onRestEvent() {
    },
    getTaskList(params) {
      return this.getHttpServices().getUserService().post('staff/marketTaskReceive/geTaskDetailListBytMerchantId', params)
    }
  }

}
</script>
<style scoped>
</style>